import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from './user.service';
import { NavController } from '@ionic/angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private navCtrl: NavController, private userService: UserService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				(event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						if (event.body.status === 'Unauthorized') {
							this.userService.remove();
							this.navCtrl.navigateRoot('');
						}
					}
				},
				(err: any) => {
					if (err instanceof HttpErrorResponse) {
					}
				}
			)
		);
	}
}
